import { AsyncNotFound } from 'pages/async';

export default [
  {
    name: 'Not Found',
    component: AsyncNotFound,
  },
];
